import { Link } from "react-router-dom";

const footerLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Story", href: "#story" },
  { label: "Characters", href: "#characters" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

const handleNav = (href: string) => {
  const id = href.replace("#", "");
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function Footer() {
  return (
    <footer className="w-full bg-[#111] border-t border-[#8B1A1A]/30 py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-sword-line text-[#C8922A] text-lg" />
              </div>
              <span className="font-['Special_Elite'] text-white text-lg tracking-[0.15em] uppercase">
                The <span className="text-[#C8922A]">Wraith</span>
              </span>
            </div>
            <p className="font-['Rajdhani'] text-[#666] text-sm leading-relaxed">
              Jordan Reyes. Her protectiveness isn&apos;t just romantic — it&apos;s atonement. Every swing of &ldquo;Home-Run&rdquo; is a promise kept.
            </p>
            <div className="flex items-center gap-3 mt-6">
              {[
                { icon: "ri-instagram-line", href: "#contact", external: false },
                { icon: "ri-youtube-line", href: "#contact", external: false },
                { icon: "ri-facebook-line", href: "https://www.facebook.com/profile.php?id=61577407843549", external: true },
                { icon: "ri-tiktok-line", href: "https://www.tiktok.com/@wraithandthechef", external: true },
              ].map(({ icon, href, external }) => (
                <a
                  key={icon}
                  href={href}
                  rel="nofollow"
                  target={external ? "_blank" : undefined}
                  onClick={!external ? (e) => { e.preventDefault(); handleNav(href); } : undefined}
                  className="w-9 h-9 flex items-center justify-center border border-[#2C2C2C] hover:border-[#8B1A1A] text-[#555] hover:text-[#C8922A] transition-all duration-300 cursor-pointer"
                >
                  <i className={`${icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-['Share_Tech_Mono'] text-[#C8922A] text-xs tracking-[0.25em] uppercase mb-5">
              <a href="#home" className="hover:text-[#C8922A]">Navigation</a>
            </h4>
            <ul className="space-y-3">
              {footerLinks.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => handleNav(link.href)}
                    className="font-['Rajdhani'] text-[#666] hover:text-white text-sm tracking-wide transition-colors cursor-pointer flex items-center gap-2"
                  >
                    <span className="w-1 h-1 bg-[#8B1A1A] rounded-full" />
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Mission */}
          <div>
            <h4 className="font-['Share_Tech_Mono'] text-[#C8922A] text-xs tracking-[0.25em] uppercase mb-5">
              <a href="#story" className="hover:text-[#C8922A]">The Mission</a>
            </h4>
            <div className="space-y-4">
              <div className="border-l-2 border-[#8B1A1A]/60 pl-4">
                <div className="font-['Share_Tech_Mono'] text-[#444] text-xs tracking-widest uppercase mb-1">
                  Objective
                </div>
                <div className="font-['Rajdhani'] text-[#777] text-sm">
                  Locate Aidan. Bring him home.
                </div>
              </div>
              <div className="border-l-2 border-[#C8922A]/40 pl-4">
                <div className="font-['Share_Tech_Mono'] text-[#444] text-xs tracking-widest uppercase mb-1">
                  Status
                </div>
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-[#C8922A] animate-pulse" />
                  <span className="font-['Rajdhani'] text-[#C8922A] text-sm">In Progress</span>
                </div>
              </div>
              <div className="border-l-2 border-[#333] pl-4">
                <div className="font-['Share_Tech_Mono'] text-[#444] text-xs tracking-widest uppercase mb-1">
                  Days Since Green Monday
                </div>
                <div className="font-['Special_Elite'] text-[#888] text-lg">847+</div>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-[#1E1E1E] pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-['Share_Tech_Mono'] text-[#333] text-xs tracking-widest">
            &copy; 2026 The Wraith Chronicles. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/privacy-policy"
              className="font-['Share_Tech_Mono'] text-[#333] hover:text-[#C8922A]/60 text-xs tracking-widest transition-colors duration-300 whitespace-nowrap"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms-of-use"
              className="font-['Share_Tech_Mono'] text-[#333] hover:text-[#C8922A]/60 text-xs tracking-widest transition-colors duration-300 whitespace-nowrap"
            >
              Terms of Use
            </Link>
            <div className="font-['Share_Tech_Mono'] text-[#333] text-xs tracking-widest hidden lg:block">
              &ldquo;She will not let it happen again.&rdquo;
            </div>
          </div>
        </div>

        {/* Watermark */}
        <div className="text-center mt-4 overflow-hidden">
          <span
            className="font-['Special_Elite'] text-[#1A1A1A] select-none pointer-events-none"
            style={{ fontSize: "clamp(3rem, 10vw, 8rem)", letterSpacing: "0.1em" }}
          >
            WRAITH
          </span>
        </div>
      </div>
    </footer>
  );
}
